import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const linkVariants = cva(
	'',
	{
		variants: {
			variant: {
				default: 'text-primary hover:text-primary/90 hover:underline',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
)

export type LinkVariants = VariantProps<typeof linkVariants>
